<template>
  <main class="auth-account">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          :disabled="type === 'edit'"
          v-model="ruleForm.username"
          placeholder="请输入邮箱账号用于登录"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model="ruleForm.mobile"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input
          v-model="ruleForm.nickname"
          placeholder="请输入姓名作为昵称"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          :disabled="type === 'edit'"
          v-model="ruleForm.password"
          placeholder="请创建8-16位初始密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户角色" prop="checkedRoles">
        <el-checkbox-group v-model="ruleForm.checkedRoles">
          <el-checkbox
            v-for="role in auth.allRoles"
            :label="role.roleCode"
            :key="role.roleCode"
            >{{ role.roleName }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <!-- <el-form-item  label="账号状态" prop="enable">
        <el-switch v-model="enable"></el-switch> <span>{{ enable ? '启用': '禁用'}}</span>
      </el-form-item> -->
    </el-form>
  </main>
</template>

<script>
import eventBus from '../../../utils/fresh-table'
export default {
  created() {
    this.$store.dispatch('auth/GET_ALL_ROLES')
    if (this.type === 'edit') {
      // 编辑的时候付初始值
      this.ruleForm.username = this.data.username
      this.ruleForm.nickname = this.data.nickname
      this.ruleForm.password = '***********'
      this.ruleForm.mobile = this.data.mobile
      // this.enable = this.data.enable
      this.roles = this.data.roles
      if (this.roles && this.roles.length) {
        this.data.roles.forEach((element) => {
          if (element.auth) {
            this.ruleForm.checkedRoles.push(element.roleCode)
          }
        })
      }
    }
  },
  data() {
    return {
      // enable: false,
      ruleForm: {
        username: '',
        nickname: '',
        password: '',
        roles: [],
        checkedRoles: [],
      },
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          {
            max: 20,
            message: '用户名最多为20个字符',
            type: 'email',
            trigger: 'blur',
          },
        ],
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            trigger: 'blur',
            pattern: /^\s*[1]{1}[0-9]{10}\s*$/,
            message: '手机号格式不正确',
          },
        ],
        nickname: [
          { required: true, message: '昵称不能为空', trigger: 'blur' },
          { max: 10, message: '最长为10个汉字', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            min: 8,
            max: 16,
            message: '密码长度请控制在8-16位字符内',
            trigger: 'blur',
          },
        ],
        checkedRoles: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个用户角色',
            trigger: 'change',
          },
        ],
      },
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    type: {
      type: String,
      default() {
        return ''
      },
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth
    },
  },
  methods: {
    validateMain(rule, value, callback) {
      const { reg, error } = rule
      if (reg.test(value)) {
        return callback()
      }
      return callback(new Error(error))
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm.password = this.ruleForm.password.replace(
            '***********',
            ''
          )
          this.ruleForm.roles = this.ruleForm.checkedRoles
          const url =
            this.type === 'edit'
              ? '/proxy/auth/user/edit'
              : '/proxy/auth/user/add'
          let params = {
            ...this.ruleForm,
            // enable: this.enable
          }
          delete params.checkedRoles
          if (this.type === 'edit') {
            params = Object.assign({}, params, {
              userId: this.data.userId,
            })
          }
          this.$request({
            url,
            method: 'post',
            data: params,
          }).then((res) => {
            if (!res.errorCode) {
              if (this.type === 'create') {
                this.$router.push({
                  path: '/console/user-manage/user-account',
                })
                this.$message({
                  message: '已成功添加新用户账号',
                  type: 'success',
                })
              } else {
                this.$store.commit('auth/update', {
                  isShowAccountEditDialog: false,
                })
                this.$message('账号信息已保存')
                eventBus.$emit('freshTable')
              }
            } else {
              this.$message.error(res.errorMsg)
            }
          })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="stylus">
.auth-account
  .el-input
    width 240px
  .el-checkbox+.el-checkbox
    margin-right 20px
    margin-left 0
  .el-checkbox
    margin-right 20px
    min-width 164px
</style>
